import React from "react";
import { useAuth0 } from "../../providers/AuthProvider";
import "./index.css";
import { useNavigate } from "react-router";
import { ROUTES } from "../../config/routes";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AutoAwesomeMotionOutlinedIcon from "@mui/icons-material/AutoAwesomeMotionOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";

const Navbar: React.FC = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  const [value, setValue] =
    React.useState<(typeof ROUTES)[keyof typeof ROUTES]>("/");

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: (typeof ROUTES)[keyof typeof ROUTES]
  ) => {
    console.log(`Navigating from ${value} to ${newValue}`);
    setValue(newValue);
    navigate(newValue);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        display: "inline-block",
        height: "100vh",
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          borderRight: 1,
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          ".MuiTabs-flexContainer": {
            display: "flex",
            height: "100vh",
          },
        }}
      >
        <Tab
          label="Batch Data"
          onClick={() => {
            navigate(ROUTES.HOME);
          }}
          icon={
            <AutoAwesomeMotionOutlinedIcon
              className={"icon-flipped"}
              fontSize="large"
            />
          }
          value={ROUTES.HOME}
        />
        <Tab
          label="Reports"
          icon={<AssessmentOutlinedIcon fontSize="large" />}
          value={ROUTES.REPORTS}
        />

        <Tab
          className="btn-collection-details"
          label={
            <div>
              Collection
              <br />
              Details
            </div>
          }
          icon={<BorderColorOutlinedIcon fontSize="large" />}
          value={ROUTES.COLLECTIONSSITES}
        />
        <Tab label="" disabled sx={{ flexGrow: 1 }} />
        <Tab
          className="tab-setting"
          label="Setting"
          icon={<SettingsOutlinedIcon fontSize="large" />}
          value={ROUTES.SETTINGS}
        />
        <Tab
          className="btn-logout"
          label="Logout"
          icon={<LogoutIcon fontSize="large" />}
          onClick={() => {
            logoutWithRedirect();
          }}
          value={ROUTES.SETTINGS}
        />
      </Tabs>
    </Box>
  );
};

export default Navbar;
